import LegalLayout, { H2, P, UL, B } from "./LegalLayout";

export default function Precontractuale() {
    return (
        <LegalLayout title="Informații precontractuale" updated="iunie 2026">
            <P>
                Prezentele informații sunt furnizate în conformitate cu <B>Legea nr. 236/2018</B> privind
                distribuția de asigurări și cu <B>Norma ASF nr. 19/2018</B>, înainte de încheierea oricărui
                contract de asigurare intermediat.
            </P>

            <H2>1. Identitatea distribuitorului</H2>
            <UL
                items={[
                    <><B>Ilaș Gabriela Elena</B> — asistent în brokeraj (intermediar secundar), care desfășoară activitate de distribuție de asigurări în numele și în contul brokerului de mai jos, sub marca OPTIM SAFE.</>,
                    <><B>SAFETY BROKER DE ASIGURARE S.A.</B> — broker de asigurare, cu sediul în Calea Giulești nr. 8D, et. 2, sector 6, București; înmatriculat în Registrul Brokerilor sub nr. <B>RBK-293/15.06.2005</B>; autorizat prin Decizia CSA nr. 3894/13.06.2005; CUI 17437817; J40/6184/2005; parte a grupului global Acrisure.</>,
                ]}
            />

            <H2>2. Verificarea înregistrării</H2>
            <P>
                Înregistrarea Safety Broker de Asigurare S.A. și a intermediarilor săi secundari poate fi
                verificată în registrele publice ale <B>Autorității de Supraveghere Financiară (ASF)</B>,
                disponibile la adresa{" "}
                <a href="https://asfromania.ro" target="_blank" rel="noopener noreferrer" className="underline">
                    asfromania.ro
                </a>{" "}
                (secțiunea Registre entități autorizate).
            </P>

            <H2>3. Natura serviciilor</H2>
            <P>
                Distribuim produse de asigurare din partea mai multor societăți de asigurare cu care Safety Broker
                colaborează. Recomandările noastre se bazează pe o <B>analiză imparțială</B> a unui număr suficient
                de mare de contracte de asigurare disponibile pe piață, astfel încât să putem recomanda produsul
                adecvat nevoilor dumneavoastră (analiza cerințelor și necesităților clientului — DNT).
            </P>

            <H2>4. Remunerarea</H2>
            <UL
                items={[
                    <>Serviciile de consultanță și intermediere sunt <B>gratuite pentru client</B> — nu percepem niciun onorariu sau comision direct de la dumneavoastră.</>,
                    <>Pentru activitatea de distribuție, brokerul și intermediarii săi sunt remunerați printr-un <B>comision inclus în prima de asigurare</B>, plătit de societatea de asigurare emitentă. Prima plătită de client este aceeași ca la achiziția directă de la asigurător.</>,
                ]}
            />

            <H2>5. Participații</H2>
            <P>
                Distribuitorul nu deține participații directe sau indirecte de 10% sau mai mult din drepturile de
                vot sau din capitalul vreunei societăți de asigurare, iar nicio societate de asigurare nu deține
                participații directe sau indirecte în capitalul distribuitorului.
            </P>

            <H2>6. Petiții și reclamații</H2>
            <P>Dacă sunteți nemulțumit(ă) de serviciile de distribuție, puteți depune o reclamație:</P>
            <UL
                items={[
                    <>Direct către noi, la <B>office@optimsafe.ro</B> sau telefonic la <B>0745 643 348</B>;</>,
                    <>Către <B>Safety Broker de Asigurare S.A.</B> — office@safetybroker.ro, telefon 021.745.62.69;</>,
                    <>Către <B>ASF</B> — <a href="https://asfromania.ro" target="_blank" rel="noopener noreferrer" className="underline">asfromania.ro</a>, secțiunea Petiții;</>,
                    <>Către <B>SAL-Fin</B> — soluționarea alternativă a litigiilor: <a href="https://salfin.ro" target="_blank" rel="noopener noreferrer" className="underline">salfin.ro</a>.</>,
                ]}
            />

            <H2>7. Documente contractuale</H2>
            <P>
                Înainte de încheierea oricărui contract de asigurare veți primi documentul de informare
                standardizat al produsului (<B>PID / IPID</B>), condițiile de asigurare complete și analiza
                cerințelor și necesităților dumneavoastră, conform legislației în vigoare.
            </P>
        </LegalLayout>
    );
}
